import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const { setUser } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
      navigate("/admin");
    } catch (err) {
      setError(apiError(err));
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-sage px-4 font-body">
      <div className="w-full max-w-sm rounded-3xl border border-leafline bg-cream p-8 shadow-xl shadow-artichoke/10">
        <div className="flex flex-col items-center">
          <img src="/logo.png" alt="" className="h-16 w-16 rounded-full shadow-md" />
          <h1 className="mt-4 font-display text-2xl font-bold text-deep" data-testid="login-title">
            Owner Login
          </h1>
          <p className="mt-1 text-sm text-chalk/50">Giant Artichoke Cafe & Grill</p>
        </div>
        <form onSubmit={submit} className="mt-7 space-y-4">
          <input
            data-testid="login-email-input"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            className="w-full rounded-2xl border-2 border-chalk/10 bg-white px-4 py-3 text-sm font-medium outline-none transition-colors placeholder:text-chalk/35 focus:border-artichoke"
          />
          <input
            data-testid="login-password-input"
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            className="w-full rounded-2xl border-2 border-chalk/10 bg-white px-4 py-3 text-sm font-medium outline-none transition-colors placeholder:text-chalk/35 focus:border-artichoke"
          />
          {error && (
            <p data-testid="login-error" className="rounded-xl bg-red-50 px-4 py-2.5 text-sm font-semibold text-red-700">
              {error}
            </p>
          )}
          <button
            data-testid="login-submit-button"
            type="submit"
            disabled={busy}
            className="w-full rounded-full bg-artichoke py-3.5 font-display text-base font-semibold text-cream transition-all hover:bg-deep disabled:opacity-60"
          >
            {busy ? "Signing in…" : "Sign In"}
          </button>
        </form>
        <a href="/" data-testid="login-back-link" className="mt-5 block text-center text-sm font-semibold text-artichoke hover:text-grape">
          ← Back to the site
        </a>
      </div>
    </div>
  );
}
